import type { BrandingPreset, ColorPreset } from "../page/domain";
import { ColorLabels } from "./constants";
import { getFullTheme } from "./theme-colors";

export const transformColorPreset = ({
  theme,
  isPredefined,
  ...preset
}: ColorPreset): BrandingPreset => {
  return {
    ...preset,
    isPredefined,
    config: {
      ...(isPredefined
        ? (getFullTheme({
            primary: theme[ColorLabels["BRAND-PRIMARY"]],
            light: theme[ColorLabels["NEUTRAL-PRIMARY"]],
            dark: theme[ColorLabels["DARK-SECONDARY"]],
          }) as Record<string, string>)
        : theme),
      buttonBorderRadius: theme.buttonBorderRadius || "4px",
      inputBorderRadius: theme.inputBorderRadius || "4px",
    },
  };
};
